import { withMarkdownOnChange } from './onChange';
import { withMarkdownNormalizeNode } from './normalizeNode';
export const withMarkdownNormalization = (editor, listeners) => {
    return withMarkdownOnChange(withMarkdownNormalizeNode(editor, listeners), listeners);
};
//# sourceMappingURL=index.js.map